import dayjs from 'dayjs';
import 'dayjs/locale/fr';
import 'dayjs/locale/vi';
import customParseFormat from 'dayjs/plugin/customParseFormat';
import duration from 'dayjs/plugin/duration';
import relativeTime from 'dayjs/plugin/relativeTime';
import timezone from 'dayjs/plugin/timezone';
import updateLocale from 'dayjs/plugin/updateLocale';
import utc from 'dayjs/plugin/utc';

dayjs.extend(utc);
dayjs.extend(timezone);
dayjs.extend(relativeTime);
dayjs.extend(updateLocale);
dayjs.extend(customParseFormat);
dayjs.extend(duration);

dayjs.updateLocale('en', {
  weekStart: 1,
});
dayjs.updateLocale('fr', {
  weekStart: 1,
});

export const dayjsGlobal = dayjs;
